import React, { PropsWithChildren } from "react";

import MediaQuery from "react-responsive";
import { ScreenSize } from "./Responsive.types";

/**
 * It renders components when user screen size is above 767px.
 * @param LargeScreen props.
 * @returns Component optimized for large screen.
 */
export const LargeScreen = (props: PropsWithChildren<{}>) => <MediaQuery minWidth={ScreenSize.Small}>{props.children}</MediaQuery>;
